var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRLogo = function SvgRLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#C7E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.19 15.533 5.141 6.934H7.137V5.49h7.99c.28 0 .534.011.77.032a5.16 5.16 0 0 1 1.293 10.011Z",
    fill: "#157EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.032 22.467H7.137V5.49l15.089 16.977h-5.194Z",
    fill: "#157EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.331 22.467H7.138l7.544-11.856 7.65 11.856Z",
    fill: "#00BDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.137 15.314V5.49h4.24l6.336 9.823-10.576.001Z",
    fill: "#1560FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.69 15.316 2.992-4.705 3.034 4.705H11.69Z",
    fill: "#00EFE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.331 22.467h-5.645L14.682 10.61l7.65 11.856Z",
    fill: "#157EFF",
    fillOpacity: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRLogo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiByeD0iNCIgZmlsbD0iI0M3RTRGRiIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJtMTcuMTkgMTUuNTMzIDUuMTQxIDYuOTM0SDcuMTM3VjUuNDloNy45OWMuMjggMCAuNTM0LjAxMS43Ny4wMzJhNS4xNiA1LjE2IDAgMCAxIDEuMjkzIDEwLjAxMVoiIGZpbGw9IiMxNTdFRkYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjAzMiAyMi40NjdINy4xMzdWNS40OWwxNS4wODkgMTYuOTc3aC01LjE5NFoiIGZpbGw9IiMxNTdFRkYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjMzMSAyMi40NjdINy4xMzhsNy41NDQtMTEuODU2IDcuNjUgMTEuODU2WiIgZmlsbD0iIzAwQkRGRiIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4xMzcgMTUuMzE0VjUuNDloNC4yNGw2LjMzNiA5LjgyMy0xMC41NzYuMDAxWiIgZmlsbD0iIzE1NjBGQSIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJtMTEuNjkgMTUuMzE2IDIuOTkyLTQuNzA1IDMuMDM0IDQuNzA1SDExLjY5WiIgZmlsbD0iIzAwRUZFOSIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjIuMzMxIDIyLjQ2N2gtNS42NDVMMTQuNjgyIDEwLjYxbDcuNjUgMTEuODU2WiIgZmlsbD0iIzE1N0VGRiIgZmlsbC1vcGFjaXR5PSIuNSIvPjwvc3ZnPg==";